import React, {Component} from 'react';
import Select from"../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import Alert from "react-s-alert";
import {Label, UncontrolledTooltip} from 'reactstrap';
import {validateField} from "../../../common/validation";
import {deepCopyObject} from "../../../helper/helper";
import {isValidNoIdentifier} from "../../../common/componentValidation";
import DefaultModal from "../DefaultModal";
import MaskedInput from "react-text-mask";

class ConnectorExCustomerModal extends Component {

	constructor(props) {
		super(props);
		this.state = {error: {}, docExternalCustomer: null, locationSelect: true};
		this.isOpen 		= this.isOpen.bind(this);
		this.validateField 	= this.validateField.bind(this);
		this.onChange 		= this.onChange.bind(this);
		this.checkValue 	= this.checkValue.bind(this);
		this.setNoIdentifier= this.setNoIdentifier.bind(this);
		this.getSubdivisionsForCity= this.getSubdivisionsForCity.bind(this);
	}

	componentDidMount() {
		let docExternalCustomer = deepCopyObject(this.state.docExternalCustomer);
		this.setState({locationSelect: !(docExternalCustomer.manualInput && docExternalCustomer.manualInput === 1)})
	}

	componentWillMount() {
		this.setState({
			docExternalCustomer: this.props.docExternalCustomer,
			modal: this.props.modal,
			title: this.props.title
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	setNoIdentifier(e) {
		e.preventDefault();
		let docExternalCustomer = deepCopyObject(this.state.docExternalCustomer);
		let result = isValidNoIdentifier(docExternalCustomer);
		let error = result.error;
		let valid = result.valid;
		if (valid) {
			this.props.listener(docExternalCustomer);
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			this.setState({error});
		}
	}

	onChange(e) {
		if (e.target && e.target.id && e.target.value && e.target.id === "postalZone" && isNaN(e.target.value)) {
		} else {
			let docExternalCustomer = deepCopyObject((this.state.docExternalCustomer ? this.state.docExternalCustomer : {}));
			docExternalCustomer[e.target.name] = e.target.value;
			this.setState({docExternalCustomer});
		}
	}

	isOpen() {
		this.props.listener(this.props.docExternalCustomer);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.docExternalCustomer !== nextProps.docExternalCustomer) {
			this.setState({docExternalCustomer: nextProps.docExternalCustomer});
		}
	}

	checkValue(key){
		return ((this.state.docExternalCustomer && this.state.docExternalCustomer[key]) ? this.state.docExternalCustomer[key] :  "");
	}

	getSubdivisionsForCity(cityFieldName) {
		let city = this.state.docExternalCustomer[cityFieldName];
		if (city === null) {
			return [];
		}

		let theCity = this.props.cities.find(obj => obj.cityName === city);

		if (theCity === undefined) {
			return [];
		}

		return theCity.subdivisions.map(subdiv => ({
			value: subdiv.name,
			label: subdiv.name
		}))
	}

	locationSelect() {
		let locationSelect = !deepCopyObject(this.state.locationSelect);
		let manualInputObj = {
			target:{
				name: 'manualInput',
				value: locationSelect ? 0 : 1
			}
		};
		this.setState({
			locationSelect,
		}, () => this.onChange(manualInputObj));
	}

	render() {
		return (
			<DefaultModal
				isOpen={this.props.modal}
				title={this.props.title}
				size={"lg"}
				confirmBtnText="Kaydet"
				cancelBtnText="İptal"
				onConfirm={(e) => this.setNoIdentifier(e)}
				onCancel={this.isOpen}>
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
					{(this.props.personalFlag !== null && !this.props.personalFlag) &&
						<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
							<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
								<label>Unvan{(this.checkValue("vknTckn")).length !== 11 ? "*" : ""}</label>
							</div>
							<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
								<div className={"form-group" + this.validateClass("formattedName")}>
									<input className="form-control"
										   type="text"
										   data-vlength={(this.checkValue("vknTckn")).length !== 11 ? "2,350" : "0,350"}
										   id="formattedName"
										   name="formattedName"
										   onBlur={(e) => this.validateField(e)}
										   onChange={this.onChange}
										   value={this.checkValue("formattedName")}/>
									{this.validateMessage("formattedName") !== "" &&
										<UncontrolledTooltip placement="right" target={"formattedName"} delay={0}>
											{this.validateMessage("formattedName")}
										</UncontrolledTooltip>}
								</div>
							</div>
						</div>
					}
					{ this.props.personalFlag &&
						<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
							<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
								<label>Adı{(this.checkValue("vknTckn")).length !== 10 ? "*" : ""}</label>
							</div>
							<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
								<div className={"form-group" + this.validateClass("givenName")}>
									<input className="form-control"
										   type="text"
										   data-vlength={(this.checkValue("vknTckn")).length !== 10 ? "1,255" : "0,255"}
										   id="givenName"
										   name="givenName"
										   onBlur={(e) => this.validateField(e)}
										   onChange={this.onChange}
										   value={this.checkValue("givenName")}/>
									{this.validateMessage("givenName") !== "" &&
										<UncontrolledTooltip placement="right" target={"givenName"} delay={0}>
											{this.validateMessage("givenName")}
										</UncontrolledTooltip>}
								</div>
							</div>
						</div>
					}
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Orta Adı</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("middleName")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="middleName"
									   name="middleName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("middleName")}/>
								{this.validateMessage("middleName") !== "" &&
									<UncontrolledTooltip placement="right" target={"middleName"} delay={0}>
										{this.validateMessage("middleName")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					{this.props.personalFlag &&
						<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
							<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
								<label>Soyadı{(this.checkValue("vknTckn")).length !== 10 ? "*" : ""}</label>
							</div>
							<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
								<div className={"form-group" + this.validateClass("familyName")}>
									<input className="form-control"
										   type="text"
										   data-vlength={(this.checkValue("vknTckn")).length === 11 ? "1,255" : "0,255"}
										   id="familyName"
										   name="familyName"
										   onBlur={(e) => this.validateField(e)}
										   onChange={this.onChange}
										   value={this.checkValue("familyName")}/>
									{this.validateMessage("familyName") !== "" &&
										<UncontrolledTooltip placement="right" target={"familyName"} delay={0}>
											{this.validateMessage("familyName")}
										</UncontrolledTooltip>}
								</div>
							</div>
						</div>
					}
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Telefon</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("telephone")}>
								<MaskedInput className= 'form-control'
											 type="text"
											 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
											 placeholder="+90__________"
											 name="telephone"
											 id="telephone"
											 onBlur={() => this.validateField({
												 target: {
													 id: "telephone",
													 dataset: {vdata: "phone", vlength: '13,13'},
													 value: this.state.docExternalCustomer["telephone"]
												 }
											 })}
											 guide={true}
											 ref='telephone'
											 value={this.checkValue("telephone")}
											 onChange={(e) => this.onChange(e)}/>
								{this.validateMessage('telephone') !== "" &&
									<UncontrolledTooltip placement="right" target="telephone" delay={0}>
										{this.validateMessage("telephone")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Faks</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("fax")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="fax"
									   name="fax"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("fax")}/>
								{this.validateMessage("fax") !== "" &&
									<UncontrolledTooltip placement="right" target={"fax"} delay={0}>
										{this.validateMessage("fax")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Bina Adı</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("buildingName")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="buildingName"
									   name="buildingName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("buildingName")}/>
								{this.validateMessage("buildingName") !== "" &&
									<UncontrolledTooltip placement="right" target={"buildingName"} delay={0}>
										{this.validateMessage("buildingName")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Bina No</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("buildingNo")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="buildingNo"
									   name="buildingNo"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("buildingNo")}/>
								{this.validateMessage("buildingNo") !== "" &&
									<UncontrolledTooltip placement="right" target={"buildingNo"} delay={0}>
										{this.validateMessage("buildingNo")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Kapı No</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("postalAddressRoom")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="postalAddressRoom"
									   name="postalAddressRoom"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("postalAddressRoom")}/>
								{this.validateMessage("postalAddressRoom") !== "" &&
									<UncontrolledTooltip placement="right" target={"postalAddressRoom"} delay={0}>
										{this.validateMessage("postalAddressRoom")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Cadde/Mahalle</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("streetName")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="streetName"
									   name="streetName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("streetName")}/>
								{this.validateMessage("streetName") !== "" &&
									<UncontrolledTooltip placement="right" target={"streetName"} delay={0}>
										{this.validateMessage("streetName")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Posta Kodu</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("postalZone")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="postalZone"
									   name="postalZone"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("postalZone")}/>
								{this.validateMessage("postalZone") !== "" &&
									<UncontrolledTooltip placement="right" target={"postalZone"} delay={0}>
										{this.validateMessage("postalZone")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>E-Posta</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("email")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   data-vdata="email"
									   id="email"
									   name="email"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("email")}/>
								{this.validateMessage("email") !== "" &&
									<UncontrolledTooltip placement="right" target={"email"} delay={0}>
										{this.validateMessage("email")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Web Sitesi</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("webSite")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   data-vdata="url"
									   id="webSite"
									   name="webSite"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("webSite")}/>
								{this.validateMessage("webSite") !== "" &&
									<UncontrolledTooltip placement="right" target={"webSite"} delay={0}>
										{this.validateMessage("webSite")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Vergi Dairesi</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("taxOffice")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="taxOffice"
									   name="taxOffice"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("taxOffice")}/>
								{this.validateMessage("taxOffice") !== "" &&
									<UncontrolledTooltip placement="right" target="taxOffice" delay={0}>
										{this.validateMessage("taxOffice")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Ticaret Odası</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("commerceChamber")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="commerceChamber"
									   name="commerceChamber"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("commerceChamber")}/>
								{this.validateMessage("commerceChamber") !== "" &&
									<UncontrolledTooltip placement="right" target="commerceChamber" delay={0}>
										{this.validateMessage("commerceChamber")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Mersis No</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("mersisNumber")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   maxLength="16"
									   id="mersisNumber"
									   name="mersisNumber"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("mersisNumber")}/>
								{this.validateMessage("mersisNumber") !== "" &&
									<UncontrolledTooltip placement="right" target="mersisNumber" delay={0}>
										{this.validateMessage("mersisNumber")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label style={{display:"noWrap"}}>Ticaret Sicil No</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("tradeRegistrationNumber")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="tradeRegistrationNumber"
									   name="tradeRegistrationNumber"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("tradeRegistrationNumber")}/>
								{this.validateMessage("tradeRegistrationNumber") !== "" &&
									<UncontrolledTooltip placement="right" target="tradeRegistrationNumber" delay={0}>
										{this.validateMessage("tradeRegistrationNumber")}
									</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				</div>
			</DefaultModal>
		);
	}
}

export default ConnectorExCustomerModal;

